module.exports = __webpack_public_path__ + "static/media/arrow-down.788ac338.svg";